import Dictionary from '../dictionary';
import DictionaryFactory from '../dictionary-factory';
import OrganizationServer from "@/api/organization";

export const DICTIONARY_FACTORY_ORG_PROJECT = 'org_project';
export const DICTIONARY_FACTORY_ORG_PROJECT_TYPE_VALID = 'VALID';
export const DICTIONARY_FACTORY_ORG_PROJECT_TYPE_ALL = 'ALL';
export default class OrgProjectDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_ORG_PROJECT});
    }

    async getDictionary({type}) {
        let dictionary;
        switch (type) {
            case DICTIONARY_FACTORY_ORG_PROJECT_TYPE_VALID: {
                let projects = [];
                let response = await OrganizationServer.project.list({eq_status: '1'});
                if (response.data.code === '200') {
                    projects = response.data.data;
                }
                dictionary = new Dictionary({items: projects, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_ORG_PROJECT_TYPE_ALL: {
                let projects = [];
                let response = await OrganizationServer.project.list({});
                if (response.data.code === '200') {
                    projects = response.data.data;
                }
                dictionary = new Dictionary({items: projects, valueKey: 'id', textKey: 'name'});
                break;
            }
        }
        if (dictionary == null) {
            dictionary = new Dictionary({items: []});
        }
        return dictionary;
    }
}